import { ReviewRouteConfig } from '/@/modules/trustpilot/routes/ReviewRouteConfig';
import { ReviewRoute } from '/@/modules/trustpilot/constants/ReviewRoute';
import ReviewLayout from '/@/modules/trustpilot/pages/ReviewLayout.vue';

export const router = [
  {
    path: ReviewRoute.LAYOUT.path,
    name: ReviewRoute.LAYOUT.name,
    component: ReviewLayout,
    children: [
      ReviewRouteConfig.factory({
        path: ReviewRoute.REVIEW.path,
        name: ReviewRoute.REVIEW.name,
        component: () => import('/@/modules/trustpilot/pages/ReviewPage.vue'),
        meta: { authOnly: false }
      }).build()
    ]
  }
];
